import { isSSR } from "@website/utils/is-ssr";

const isProduction = process.env.NEXT_PUBLIC_BUILD_ENV === "production";

const BASE_URL = isProduction
  ? getPlatformHost()
  : "http://platform-api.asiatech.ptp";

export const BASE_URL_PROFILE = `${BASE_URL}/profile`;

function getPlatformHost() {
  if (process.env.NEXT_PUBLIC_BASE_URL_PLATFORM) {
    return process.env.NEXT_PUBLIC_BASE_URL_PLATFORM;
  }

  if (isSSR()) return "https://platform-api.snapptrip.com";
  const { protocol, hostname } = window.location;

  const parts = hostname.split(".");
  if (parts.length > 2) {
    parts.shift();
  }
  const newDomain = parts.join(".");

  return `${protocol}//platform-api.${newDomain}`;
}
